export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';
export const SET_PAGE_SUB_TITLE = 'SET_PAGE_SUB_TITLE';
